import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { OperationKeys } from '@decaf-ts/db-decorators';
import { Dynamic, IconComponent, ListItemComponent } from '@decaf-ts/for-angular';
import { IonAvatar, IonItem, IonLabel } from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import { Leaflet, LocaleHelper } from '@pharmaledgerassoc/ptp-toolkit/shared';
import { LeafletHandler } from 'src/app/handlers/LeafletHandler';
import { AuthService } from 'src/app/services/auth.service';
import { EPIDefaultWriterControlRole } from 'src/app/utils';

@Dynamic()
@Component({
  selector: 'app-leaflet-item',
  templateUrl: './leaflet-item.component.html',
  styleUrls: ['./leaflet-item.component.scss'],
  imports: [TranslatePipe, CommonModule, IonAvatar, IonItem, IonLabel, IconComponent],
  standalone: true,
})
export class AppLeafletItemComponent extends ListItemComponent implements OnInit {
  private authService: AuthService = inject(AuthService);
  isEpiWriter: boolean = false;

  override async ngOnInit() {
    this.isEpiWriter = await this.authService.isAllowed(EPIDefaultWriterControlRole);
    const { params } = this.authService.currentRouteConfig || {};
    if (params) {
      this.operation = params['operation'];
    }
    this.parseModel();
  }

  async parseModel() {
    const model = this.model as Leaflet;
    if ([OperationKeys.READ, OperationKeys.DELETE].includes(this.operation as OperationKeys)) {
      this.title = LocaleHelper.all().find((l) => l.code === model.lang)?.name || '';
      if (model.epiMarket?.length) {
        const market = LocaleHelper.getMarkets().find((m) => m.code.toLowerCase() === model.epiMarket.toLowerCase());
        if (market) {
          this.title += ' - ' + market.name;
        }
      }
      this.description = (await this.translate('leaflet.type.options.' + model.leafletType)) as string;
      if (model.batchNumber) {
        this.description += `<br />Batch: ${model.batchNumber} ${model.productCode ? ' - <span id="epi-productCode">' + model.productCode + '</span>' : ''}`;
      }
    }
  }

  async handleDelete(event: Event) {
    event.stopImmediatePropagation();
    await LeafletHandler.handleDelete(this);
  }

  override async handleAction() {
    await LeafletHandler.readFilesAndShowPreview(this.uid as string);
  }
}
